// Wrappers para /api/feedbacks/*.

import { apiFetch } from './api';

export type Attendance = 'present' | 'absent' | 'late';

export interface Feedback {
  id: number;
  booking_id: number;
  student_id: number;
  attendance: Attendance | null;
  pronunciation: number | null;
  fluency: number | null;
  structures: number | null;
  vocabulary: number | null;
  notes: string | null;
  is_complete: number;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
  booking_scheduled_at: string;
  booking_status: string;
  booking_type: 'one' | 'gr';
  teacher_id: number;
  teacher_name: string;
  lesson_id: number | null;
  lesson_title: string | null;
  student_email: string;
  student_name: string | null;
}

export interface TeacherFeedbackQueueItem {
  booking_id: number;
  scheduled_at: string;
  booking_type: 'one' | 'gr';
  lesson_id: number | null;
  lesson_title: string | null;
  student_id: number;
  student_email: string;
  student_name: string | null;
  feedback_id: number | null;
  is_complete: number | null;
  attendance: Attendance | null;
}

export async function listMyFeedbacks(): Promise<Feedback[]> {
  const r = await apiFetch<{ status: 'ok'; items: Feedback[] }>('/feedbacks/mine');
  return r.items;
}

export async function listTeacherQueue(): Promise<TeacherFeedbackQueueItem[]> {
  const r = await apiFetch<{ status: 'ok'; items: TeacherFeedbackQueueItem[] }>('/feedbacks/teacher/queue');
  return r.items;
}

export async function getFeedback(bookingId: number, studentId: number): Promise<Feedback | null> {
  const r = await apiFetch<{ status: 'ok'; item: Feedback | null }>(`/feedbacks/${bookingId}/${studentId}`);
  return r.item;
}

export interface FeedbackInput {
  attendance?: Attendance | null;
  pronunciation?: number | null;
  fluency?: number | null;
  structures?: number | null;
  vocabulary?: number | null;
  notes?: string | null;
  is_complete?: boolean;
}

export async function upsertFeedback(bookingId: number, studentId: number, input: FeedbackInput): Promise<Feedback | null> {
  const r = await apiFetch<{ status: 'ok'; item: Feedback | null }>(`/feedbacks/${bookingId}/${studentId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
  return r.item;
}
